// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const SettingsScreen = registerClientReference(
    function() { throw new Error("Attempted to call SettingsScreen() from the server but SettingsScreen is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/Documents/senkredi/senkredi-backoffice/app/(dashboard)/dashboard/settings/settings-screen.tsx <module evaluation>",
    "SettingsScreen",
);
